import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import Loader from '@/shared-components/loader/Loader';
import Text from '@/shared-components/text/components/Text';

import SocialsHeader from '../components/SocialsHeader';

import ThoughtInput from './components/ThoughtInput';
import useArtworkThoughts from './hooks/useArtworkThoughts';
import MentionVirtualList from './mention-virtual-list';
import ThoughtsVirtualList from './thoughts-virtual-list';

import './index.css';

export default function ArtworkThoughts({ closeSocial }) {
  const t = useTranslations('common.shared.artwork_view.socials.thoughts');
  const { loading, fetchData, loadMoreThoughts, loadRepliesOfThought, publishThought, onLikeAction, deleteThought } = useArtworkThoughts();
  const [reply, setReply] = useState(null);
  const [mention, setMention] = useState(null);

  return (
    <>
      <div 
        className="artwork-view-thoughts__container" 
        onTouchStart={e=>e.stopPropagation()} 
        onTouchEnd={e=>e.stopPropagation()} 
        onWheel={e=>e.stopPropagation()}
      >
        <SocialsHeader close={closeSocial} type="thoughts"/>

        {
          loading ?
            <Loader/>
            :
            <div className="artwork-view-thoughts__main">
              <div className="artwork-view-thoughts__body">
                {
                  fetchData.data.length === 0 ?
                    <Text
                      className="artwork-view-thoughts__empty-thoughts"
                      paragraph>
                      {t('empty')}
                    </Text>
                    :
                    <ThoughtsVirtualList
                      fetchData={fetchData}
                      loadMoreThoughts={loadMoreThoughts}
                      loadRepliesOfThought={loadRepliesOfThought}
                      setReply={setReply}
                      onLikeAction={onLikeAction}
                      deleteThought={deleteThought}
                    />                                
                }

                {Boolean(reply) && (
                  <div className="artwork-view-thoughts__reply-status">
                    <Text className="artwork-view-thoughts__reply-text font-size-small">
                      {t('replying_to')} <span>{reply.thought_creator.user_username}</span>
                    </Text>

                    <XIcon className="artwork-view-thoughts__reply-close" onClick={()=>setReply(null)}/>
                  </div>
                )}

                {Boolean(mention) && (
                  <MentionVirtualList mention={mention} setMention={setMention}/>
                )}
              </div>

              <ThoughtInput
                reply={reply}
                setReply={setReply}
                setMention={setMention}
                publishThought={publishThought}
              />
            </div>
        }
      </div>
    </>
  );
}
